import type NonEmptyText from '../non-empty-text';
import type Store from './store';
import { assertIsInstanceOfNonEmptyText, assertIsInstanceOfStore } from '../assertions';

interface IOrderType {
	readonly key: NonEmptyText;
	readonly name: NonEmptyText;
	readonly store: Store;
}

export default class OrderType implements IOrderType {
	public get key(): NonEmptyText {
		return this.#key;
	}

	public get name(): NonEmptyText {
		return this.#name;
	}

	public get store(): Store {
		return this.#store;
	}

	#key: NonEmptyText;
	#name: NonEmptyText;
	#store: Store;
	public constructor({ key, name, store }: IOrderType) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
		assertIsInstanceOfNonEmptyText(name);
		this.#name = name;
		assertIsInstanceOfStore(store);
		this.#store = store;
	}
}
